import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BrandLanguage } from "../type";
import { LanguageDB } from "./Language";

export const getBrandLanguages = async (
  brandId: string,
): Promise<BrandLanguage[]> => {
  const collectionRef = collection(db, `brands/${brandId}/languages`);

  const q = query(collectionRef, orderBy("updatedAt", "desc"));

  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => new LanguageDB(doc).toBrandLanguage());
};
